module.exports = __webpack_public_path__ + "img/closeBtn.43f53695.svg";